import { useMutation } from '@tanstack/react-query';
import type { SubmitIDPAnswersRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSubmitIdpAnswers } from '../api/submitIdpAnswers.js';

export interface SubmitIdpAnswersVariables {
  data: SubmitIDPAnswersRequestT;
}

export function useSubmitIdpAnswersMutation() {
  return useMutation({
    mutationKey: ['dosespot-idp', 'submit-answers'],
    mutationFn: async ({ data }: SubmitIdpAnswersVariables) => {
      return await fetchSubmitIdpAnswers(data);
    },
  });
}
